// extracted by mini-css-extract-plugin
export var logo = "_j1-2";
export var logoWrapper = "_j1-1";
export var strip = "_j1-0";